import FlooringEditForm from "./flooring-edit-form";
import FlooringFiltersForm from "./flooring-filters-form";

const FlooringForms = {
  Edit: FlooringEditForm,
  Filter: FlooringFiltersForm,
};

export default FlooringForms;
